import 'panic-overlay'

import React from 'react'
import { render } from 'react-dom'

import './common/reset.css'
import { App } from './App'

render(<App />, document.getElementById('root'))
